import { render, staticRenderFns } from "./SunburstChart.vue?vue&type=template&id=b075db24&"
import script from "./SunburstChart.vue?vue&type=script&lang=js&"
export * from "./SunburstChart.vue?vue&type=script&lang=js&"
import style0 from "./SunburstChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports